import { createContext, useContext, useMemo } from "react";
import { IRequesterSourceTypeService } from "../services/RequesterSourceTypeService";
import { createRequesterSourceTypeService } from "./Bootstrap";
import { useHttpRequestService } from "./HttpRequestContext";

const RequesterSourceTypeContext = createContext<IRequesterSourceTypeService | null>(null);

export const RequesterSourceTypeProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const httpRequestService = useHttpRequestService();
    const requesterSourceTypeService = useMemo(
        () => createRequesterSourceTypeService(httpRequestService),
        [httpRequestService]
    );

    return (
        <RequesterSourceTypeContext.Provider value={requesterSourceTypeService}>
            {children}
        </RequesterSourceTypeContext.Provider>
    );
}

export const useRequesterSourceTypeService = () => {
    const requesterSourceTypeService = useContext(RequesterSourceTypeContext);
    if (!requesterSourceTypeService) {
        throw new Error('useRequesterSourceTypeService must be used within a RequesterSourceTypeProvider');
    }
    return requesterSourceTypeService;
};
